import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicBasedVenuesRepository from "../repositories/PublicBasedVenuesRepository";

const usePublicBasedVenuesService = () => {
  const repository = new PublicBasedVenuesRepository();

  const modelService = useModelService(repository);

  return {
    ...modelService,
  };
};

export default usePublicBasedVenuesService;
